<template>
  <div>
    <section class="header">
      <el-page-header @back="goBack" content="作业统计"></el-page-header>
      <!-- <DateSelect @dateChange="dateChange"></DateSelect> -->
      <section>
        <CourseSelect v-if="classInfo.cate === 2" @courseChange="courseChange"></CourseSelect>
        <DateSelects @dateChange="dateChange"></DateSelects>
      </section>
    </section>
    <el-card v-if="
      (categories.length > 0 && classInfo.cate === 1) ||
      (stu_pieData.length > 0 && classInfo.cate === 2)
    " shadow="never" class="statistics">
      <h3>
        {{ classInfo.course_name }}作业情况统计
      </h3>
      <div class="statistics-top">
        <bar v-if="categories.length && classInfo.cate === 1" :categories="categories" :series="barData"
          @getBarIndex="getBarIndex"></bar>
        <lines v-if="classInfo.cate === 2" :categories="stu_categories" :series="stu_line_series"></lines>
      </div>
      <div class="statistics-bottom">
        <!-- <h3>作业情况详情</h3> -->
        <span>{{ start_time.replace(/-/g, '/') }} -
          {{ end_time.replace(/-/g, '/') }}期间作业情况</span>
        <!-- 老师端 -->
        <section v-if="classInfo.cate === 1" class="bottom-content">
          <pie v-if="pieData.length" :id="'teacher'" :pieData="pieData"></pie>
          <statistics-list :studentData="studentData" @goStudentStatistics="goStudentStatistics"></statistics-list>
          <!-- 学生统计弹窗 -->
          <StudentDiolag v-if="studentDiolag" :studentDiolag="studentDiolag" :categories="stu_categories"
            :series="stu_line_series" :pieData="stu_pieData" :user_name="user_name" @handleClose="handleClose">
          </StudentDiolag>
        </section>
        <!-- 学生端 -->
        <section v-if="classInfo.cate === 2" class="bottom-content2">
          <pie v-if="stu_pieData.length" :id="'student'" :pieData="stu_pieData" :width="750" :height="250"
            :type="'student'"></pie>
        </section>
      </div>
    </el-card>
    <el-empty v-else></el-empty>
  </div>
</template>

<script>
import DateSelects from "../../../components/filterComponent/DateSelects.vue"
import CourseSelect from "../../../components/filterComponent/CourseSelect.vue"
import Bar from "./components/Bar.vue"
import Pie from "./components/Pie.vue"
import Lines from "./components/Lines.vue"
import StatisticsList from "./components/StatisticsList.vue"
import StudentDiolag from "./components/StudentDiolag.vue"
import { mapState } from "vuex"
export default {
  components: {
    Bar,
    Pie,
    Lines,
    StatisticsList,
    DateSelects,
    StudentDiolag,
    CourseSelect,
  },
  data () {
    return {
      class_id: this.$store.state.classInfo.id,
      start_time: "",
      end_time: "",
      categories: [],
      barData: [], //柱状图数据
      pieData: [], //饼图数据
      workIds: [],
      work_id: "",
      // 学生统计需要的数据
      studentData: [], //学生反馈数据
      stu_pieData: [], // 学生统计饼图
      stu_categories: [], // 学生统计-折线图日期
      stu_line_series: [], // 学生统计-折线图数据
      course_id: this.$store.state.classInfo.course_id,
      studentDiolag: false,
      user_name: "",
      student_id: Number(localStorage.getItem("user_id")),
    }
  },
  computed: {
    ...mapState({
      classInfo: (state) => state.classInfo,
    }),
  },
  watch: {
    "classInfo.course_id" (val) {
      this.class_id = this.classInfo.id
      this.course_id = this.classInfo.course_id
      if (this.classInfo.cate === 1) {
        this.getBarData()
      } else if (this.classInfo.cate === 2) {
        this.getStudentStatistics()
        this.getStudentPie()
      }
    },
  },
  mounted () {
    if (this.classInfo.cate === 1) {
      this.getBarData()
    }
  },
  methods: {
    async getBarData () {
      const { data: res } = await this.$axios.post(
        "base/homework/stat/class/state",
        {
          class_id: this.class_id,
          start_time: this.start_time,
          end_time: this.end_time,
        }
      )
      if (res.errCode === 0 && res.data.length !== 0) {
        this.categories = res.data.categories
        this.barData = res.data.series
        this.workIds = res.data.ids
        this.work_id = res.data.ids[0]
        this.getPieData()
        this.getStudents()
      } else if (res.data.length === 0) {
        this.categories = []
      }
    },
    // 获取点击柱状图之后的index,更新当前的work_id
    getBarIndex (index) {
      this.work_id = this.workIds[index]
      this.getPieData()
      this.getStudents()
    },
    async getPieData () {
      const { data: res } = await this.$axios.post(
        "base/homework/stat/work/state",
        {
          class_id: this.class_id,
          work_id: this.work_id,
        }
      )
      if (res.errCode === 0) {
        this.pieData = res.data.series.map((item) => {
          return {
            value: item.data,
            name: item.name,
          }
        })

        // this.pieData = res.data.series
      }
    },
    dateChange (val) {
      this.start_time = val[0]
      this.end_time = val[1]
      if (this.classInfo.cate === 1) {
        this.getBarData()
      } else if (this.classInfo.cate === 2) {
        this.getStudentStatistics()
        this.getStudentPie()
      }
    },

    // 获取学生的信息
    async getStudents () {
      const { data: res } = await this.$axios.post(
        "base/homework/stat/score/students",
        {
          class_id: this.class_id,
          work_id: this.work_id,
        }
      )
      if (res.errCode === 0) {
        this.studentData = res.data
      }
    },

    // 学生端的数据
    courseChange (val) {
      this.course_id = val
      this.getStudentStatistics()
      this.getStudentPie()
    },

    // 查看学生作业内容
    goStudentStatistics (val) {
      const { name, id } = val
      this.studentDiolag = true
      this.user_name = name
      this.student_id = id
      this.getStudentStatistics()
      this.getStudentPie()
      // console.log(this.$refs.sdialog,this.$refs.sdialog.$attrs.categories)
    },
    //获取学生统计信息
    async getStudentStatistics () {
      // const student_id = Number(localStorage.getItem('user_id'))

      const { data: res } = await this.$axios.post(
        "base/homework/stat/student/state",
        {
          course_id: this.course_id,
          start_time: this.start_time,
          end_time: this.end_time,
          student_id: this.student_id,
        }
      )
      if (res.errCode === 0 && res.data.length != 0) {
        this.stu_categories = res.data.categories
        this.stu_line_series = res.data.series
      } else {
        console.log(res.message)
      }
    },
    async getStudentPie () {
      // const student_id = Number(localStorage.getItem('user_id'))
      const { data: res } = await this.$axios.post(
        "base/homework/stat/student/sector",
        {
          course_id: this.course_id,
          start_time: this.start_time,
          end_time: this.end_time,
          student_id: this.student_id,
        }
      )
      if (res.errCode === 0) {
        this.stu_pieData = res.data.map((item) => {
          return {
            value: item.data,
            name: item.name,
          }
        })
      } else {
        console.log(res.message)
      }
    },

    handleClose () {
      this.studentDiolag = false
    },

    goBack () {
      this.$router.push("/housework")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/common.scss";

.statistics {
  h3 {
    font-size: 18px;
    margin-top: 0;
  }

  .statistics-bottom {
    margin-top: 24px;
    padding-top: 24px;
    box-sizing: border-box;
    border-top: 1px solid #d8e2eb;

    h3 {
      margin-top: 24px;
      font-weight: 400;
      color: #1b2422;
    }

    .bottom-content {
      display: flex;
    }

    .bottom-content2 {
      display: flex;
      justify-content: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/houseworkStatistic/index.vue